
import { useStore } from "vuex"
import { PropType, defineComponent } from "vue";
export default defineComponent({
 name: "GenericPanel",
 components: {},
 props: {
  className: {
    type: String,
    default: '',
  },
  title: {
    type: String,
    default: '',
  },
  showInfo: {
    type: Array as PropType<string[]>,
    default: () => ['Default', '']
  },
  centerY: {
    type: Boolean,
    default: false,
  },
  contentWidth: {
    type: String,
    default: '92%',
  },
  titleFontSize: {
    type: String,
    default: '',
  }
 },
 setup(props) {
  const store = useStore();
  const updateInfoPanel = () => {
    const [category, stat] = props.showInfo;
    if (category && stat) {
      store.dispatch('handleIncomingCommand', {
          command: 'updateInfoPanel',
          data: { category, stat }
      });
    }
    };
    return {
      state: store.state,
      updateInfoPanel,
   }
 },
})
